module.exports = __webpack_public_path__ + "static/media/heart35.fc5fe443.svg";